import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { EventService } from './event.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  public PASSWORD_LENGTH = 8;
  country = environment.country;

  constructor(private storage: StorageService, private router: Router, private event: EventService) { }

  isEmpty(value): boolean {
    return value == "";
  }

  notEmpty(value): boolean {
    return !this.isEmpty(value);
  }

  logout() {
    localStorage.clear();
    this.event.setAccessTokenChanges(false);
    this.storage.deleteAllCookies();
    this.router.navigateByUrl('login');
  }

  isEmail(value): boolean {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(value).toLowerCase());
  }

  isPassword(password): boolean {
    return password.length >= this.PASSWORD_LENGTH;
  }

  isPass(value): Boolean {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(String(value));
  }

  isMobile(mobile): boolean {
    if(this.country == 'SA' || this.country == 'BR'){
      const regex =  /^\d{9}$/;
      return regex.test(mobile);
    }else{
      const regex = /^\d{10}$/;
      return regex.test(mobile);
    }
  }
  isNumber(value):Boolean{
    const regex = /^\d*[0-9]+\d*$/
    return regex.test(value);
  }
  isVehicle(vehicle): boolean {
    const regex = /^[a-zA-Z]{2}\s?\d{2}\s?[a-zA-Z]{0,3}\s?\d{1,4}$/;
    return regex.test(vehicle);
  }
  isKsaVehicle(vehicle): boolean {
    const regex = /[0-9]{4} [a-zA-Z]{3}|[a-zA-Z]{3} [0-9]{4}/;
    return regex.test(vehicle);
  }
  
  isGst(gst) {
    if(this.country == 'IN'){
      let regTest = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(gst)
      if(regTest){
        return (gst[14] == this.calcCheckSum(gst.toUpperCase()));
      }else{
        return regTest;
      }
    }else if(this.country == 'SA' || this.country == 'BR'){
      const regex = /^\d{15}$/;
      return regex.test(gst);
    }
  }

  //calculate checksum for last digit of GST
  calcCheckSum(g){
    let GSTN_CODEPOINT_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    factor = 2,
    sum = 0,
    checkCodePoint = 0,
    mod = GSTN_CODEPOINT_CHARS.length,
    i;
    for (i = g.length - 2; i >= 0; i--) {
      var codePoint = -1;
      for (var j = 0; j < GSTN_CODEPOINT_CHARS.length; j++) {
        if (GSTN_CODEPOINT_CHARS[j] == g[i]) {
          codePoint = j;
        }
      }
      var digit = factor * codePoint;
      factor = (factor == 2) ? 1 : 2;
      digit = Math.floor(digit / mod) + (digit % mod);
      sum += digit;
    }
    checkCodePoint = (mod - (sum % mod)) % mod;
    return GSTN_CODEPOINT_CHARS[checkCodePoint];
  }

  isIban(iban): boolean {
    const regex = /^SA\s?\d{2}\s?\d{2}\s?[0-9A-Z]{18}$/;
    return regex.test(iban);
  }
  isIfsc(ifsc): boolean {
    const regex = /^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/;
    return regex.test(ifsc);
  }
  isPan(pan): boolean {
    if(this.country == 'IN'){
      const regex = /^[A-Z]{3}[PCHFATBLJG]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;
      return regex.test(pan);
    }else if(this.country == 'SA' || this.country == 'BR'){
      const regex = /^\d{10}$/;
      return regex.test(pan);
    }
  }
}
